import { getVersionInfo } from '~/shared/lib/version'

export function VersionPage() {
  const info = getVersionInfo()

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Version Information</h1>
      <hr />
      <p>
        <strong>Version (Full Hash):</strong> {info.version || 'unknown'}
      </p>
      <p>
        <strong>Branch:</strong> {info.branch}
      </p>
      <p>
        <strong>Environment:</strong> {info.environment || 'development'}
      </p>
      <p>
        <strong>Build Time:</strong> {info.buildTime}
      </p>
      <p>
        <strong>Commit Message:</strong> {info.commitMessage || 'No commit message'}
      </p>
      {info.tag && (
        <p>
          <strong>Git Tag:</strong> {info.tag}
        </p>
      )}
      {info.pipeline && (
        <p>
          <strong>Pipeline ID:</strong> {info.pipeline}
        </p>
      )}
    </div>
  )
}
